<mat-card class="dialog-card oyan-ui-threshold-form-dialog" data-cy="oyan-ui-threshold-form-dialog">
  <mat-card-title class="dialog-card-header">
    <mat-toolbar class="dialog-toolbar" color="accent" fxLayout="row" fxLayoutAlign="space-between center">
      <h1 class="dialog-card-title">{{ 'SITES.WARDS.TABLE.ADD_THRESHOLD' | translate }}</h1>
      <button
        (click)="close()"
        class="regular-round-button"
        data-cy="oyan-ui-threshold-form-dialog-close-icon"
        mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar>
  </mat-card-title>

  <mat-card-content class="dialog-card-content" fxLayout="column" fxLayoutGap="16px" style="padding: 24px;">
    <iot-platform-ui-form-group [fields]="fields()" [group]="form" />
  </mat-card-content>

  <mat-card-actions class="dialog-card-actions" fxLayout="row" fxLayoutAlign="end center">
    <button
      (click)="close()"
      class="button-regular"
      data-cy="oyan-ui-threshold-form-dialog-close-button"
      mat-button>
      {{ 'IOT_DICTIONARY.CANCEL' | translate | uppercase }}
    </button>
    <button
      (click)="save()"
      [disabled]="!canSubmit()"
      class="button-regular"
      color="accent"
      data-cy="oyan-ui-threshold-form-dialog-save-button"
      mat-raised-button>
      {{ 'IOT_DICTIONARY.SAVE' | translate | uppercase }}
    </button>
  </mat-card-actions>
</mat-card>

